import { FunctionComponent, MouseEvent } from 'react';
import classNames from 'classnames';
import { getItemOffset } from '@nx-frontend/shared/store/feature-menu-tree';

interface MenuTreeItemActionProps {
  level: number;
  text?: string;
  isActive?: boolean;
  onClick?: (event: MouseEvent) => void;
  permissionPreviewEnabled?: boolean;
}

export const MenuTreeItemAction: FunctionComponent<MenuTreeItemActionProps> = ({
  level,
  text,
  isActive = false,
  onClick,
  permissionPreviewEnabled,
}) => {
  const paddingLeft = getItemOffset(level + 1, permissionPreviewEnabled);

  return (
    <div
      style={{ paddingLeft }}
      onClick={onClick}
      className={classNames('flex items-center py-2 pr-4 text-xs text-neutral-500 hover:text-neutral-800', {
        'bg-cyan-100': isActive,
      })}
    >
      <div className="flex">
        <div className="w-4"></div>
        <span className="whitespace-nowrap text-ellipsis overflow-hidden">{text}</span>
      </div>
    </div>
  );
};
